import { OptionType as SharedOptionType } from '../../shared/options/index';
import { TranslationKey } from '../translations';

export interface OptionOrderItem {
  optionId: number;
  orderItemId: number;
  value: string;
}

export interface OptionStyle {
  id: string;
  name: string;
}

interface OptionType {
  description: TranslationKey;
  name: TranslationKey;
  currency?: boolean;
  hidden?: boolean;
  styles?: OptionStyle[];
}

export const validOptionTypes: Record<SharedOptionType, OptionType> = {
  select: {
    description: 'option_types.allows_selecting_a_single_option_from_a_pre_defined_list',
    name: 'option_types.single_select',
    styles: [
      { id: 'radio', name: 'option_types.radio' },
      { id: 'dropdown', name: 'option_types.dropdown' },
    ],
  },
  multi: {
    description: 'option_types.allows_selecting_multiple_options_from_a_pre_defined_list',
    name: 'option_types.multi_select',
    styles: [
      { id: 'simple', name: 'option_types.checkboxes' },
      { id: 'blocks', name: 'option_types.blocks' },
    ],
  },
  text: {
    description: 'option_types.allows_the_user_to_type_arbitrary_text',
    name: 'option_types.freetext_field',
    styles: [
      { id: 'text', name: 'option_types.text' },
      { id: 'textarea', name: 'option_types.textarea' },
    ],
  },
  number: {
    description: 'option_types.allows_the_user_to_select_a_number_integer',
    name: 'option_types.number',
  },
  currency: {
    description: 'option_types.allows_the_user_to_enter_a_currency_value',
    name: 'option_types.currency',
    currency: true,
  },
  phone: {
    description: 'option_types.phone.description',
    name: 'option_types.phone',
  },
  address: {
    description: 'option_types.address.description',
    name: 'option_types.address',
  },
  file: {
    description: 'option_types.allows_the_user_to_upload_files',
    name: 'option_types.files',
    hidden: true,
  },
};
